//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/DebugSession.js";
let d=[[],[[["dimension","testType","testToleranceType","doUpdate","isTestPass","testResults"],"TestDimension",{},4,0],[["basePart","testType","testToleranceType","doUpdate","moveFailsToAnotherLayer","layerToMoveTo","stopWhenFail","outputOnlyFails","isTestPass","numOfEntries","entries"],"TestDimensions",{},8,0]],[]];
SPLM.DraftingDebugTool = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.DraftingDebugTool";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DraftingDebugTool.Testtype = Object.freeze({
    "Upgrade" : "Upgrade", "Recreate" : "Recreate", "None" : "None"});

SPLM.DraftingDebugTool.TestTolerance = Object.freeze({
    "Default" : "Default", "AutoRounded" : "AutoRounded"});

export default SPLM;